module.exports = __webpack_public_path__ + "assets/images/premium-features/messages-requires-premium-d6a09c.png";